import React, { ReactNode } from 'react';
import { connect } from 'react-redux';

import { ButtonLinkData } from 'api/cms';
import { CurrentUser } from 'api/currentUser';
import Box from 'components/Box';
import {
  PrimaryButton,
  PrimaryButtonLink,
  TrackedPrimaryButtonLink,
} from 'components/Button';
import Icon, { AnimatedCheckmark } from 'components/Icon/Icon';
import CmsSubscribeContainer from 'containers/CmsSubscribeContainer';
import { ModalType } from 'containers/types/modal.types';
import { showModal as reduxShowModal } from 'store/main/ducks/modal';
import { trackClicked } from 'utils/analytics';
import { isLoggedIn } from 'utils/currentUser';
import { getIn, stringify } from 'utils/functional';
import { fileIdToUrl } from 'utils/s3file';

const validButton = (sectionButton) =>
  !(sectionButton.type === 'CMS_PAGE' && !sectionButton.data.pageTitle);

const mapStateToProps = ({ currentUser }) => ({
  currentUser,
});

type Context = {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: (...args: Array<any>) => any;
  download: boolean;
  href: string;
};
type OwnProps = {
  eventName: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties: Record<string, any>;
  sectionButton: ButtonLinkData;
  children: (arg0: Context) => ReactNode;
};
type Props = OwnProps & {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  showModal: (arg0: ModalType, arg1: Record<string, any>) => void;
  currentUser: CurrentUser;
};
// @ts-expect-error ts-migrate(2558) FIXME: Expected 5 type arguments, but got 6.
const DownloadPermissionsContainer = connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  {
    showModal: reduxShowModal,
  }
)(
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type '({ currentUser, sectionButton, s... Remove this comment to see the full error message
  ({
    currentUser,
    sectionButton,
    showModal,
    eventName,
    eventProperties,
    children,
  }: Props) => {
    const allowDownload =
      getIn(sectionButton, ['data', 'permission']) === 'PUBLIC' ||
      isLoggedIn(currentUser);
    const href = allowDownload
      ? fileIdToUrl(stringify(sectionButton.data.s3FileId))
      : '#';

    const onClick = (e) => {
      if (!allowDownload) {
        e.preventDefault();
        e.stopPropagation();
        const redirectTo = `${window.location.pathname}${window.location.search}`;
        showModal('LOGIN', {
          redirectTo,
        });
      } else {
        trackClicked(eventName, {
          ...eventProperties,
          is_download_button: true,
        });
      }
    };

    return children({
      onClick,
      href,
      download: true,
    });
  }
);

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const ButtonLink = ({
  sectionButton,
  eventProperties,
  blockId,
  index,
}: {
  sectionButton: ButtonLinkData;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  eventProperties: Record<string, any>;
  blockId: string;
  index: number;
}) => {
  const link =
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line no-nested-ternary
    sectionButton.type === 'S3_FILE' ? (
      <DownloadPermissionsContainer
        sectionButton={sectionButton}
        eventName="CMS Block"
        eventProperties={eventProperties}
      >
        {({ onClick, href, download }) => (
          <PrimaryButtonLink
            onClick={onClick}
            href={href}
            title={sectionButton.data.pageTitle}
            data-qa-id="cms-download-button-link"
            waitForHref
          >
            <Box display="flex" alignItems="center">
              {download && (
                <Icon name="download" width={16} height={18} display="block" />
              )}
              <Box ml="8px">
                {download ? `  ${sectionButton.text}` : sectionButton.text}
              </Box>
            </Box>
          </PrimaryButtonLink>
        )}
      </DownloadPermissionsContainer>
    ) : sectionButton.type === 'SUBSCRIBE' ? (
      // @ts-expect-error ts-migrate(2786) FIXME: 'CmsSubscribeContainer' cannot be used as a JSX co... Remove this comment to see the full error message
      <CmsSubscribeContainer
        blockId={blockId}
        index={index}
        redirectUrl={sectionButton.data.redirectUrl}
        render={({ subscribe, isSubscribed }) => (
          <PrimaryButton
            onClick={() => {
              subscribe();
              trackClicked('CMS Block', eventProperties);
            }}
            data-qa-id="cms-subscribe-button-link"
            disabled={isSubscribed}
          >
            {!isSubscribed && sectionButton.text}
            {isSubscribed && (
              <>
                <AnimatedCheckmark mr="8px" stroke="white" />
                {getText('Subscribed')}
              </>
            )}
          </PrimaryButton>
        )}
      />
    ) : (
      <TrackedPrimaryButtonLink
        href={sectionButton.data.url}
        title={sectionButton.data.pageTitle}
        eventName="CMS Block"
        eventProperties={{ ...eventProperties, is_download_button: false }}
        data-qa-id="cms-button-link"
      >
        <Box display="flex" alignItems="center">
          {sectionButton.text}
        </Box>
      </TrackedPrimaryButtonLink>
    );
  return validButton(sectionButton) && <Box mt={[24, null, 36]}>{link}</Box>;
};

// eslint-disable-next-line import/no-default-export
export default ButtonLink;
